import { render, staticRenderFns } from "./FamilyIndex.vue?vue&type=template&id=63be9967&"
import script from "./FamilyIndex.vue?vue&type=script&lang=js&"
export * from "./FamilyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports